import { ENDPOINT_REQUEST, sendMsg, SERVICES_REQUEST } from "../../configurations";

export const eMessageServices = {
  getEMessageService,
  deleteEMessageService,
}

function getEMessageService(params, callback) {
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.Message.ENQUIRY_E_MESSAGE, params).get(res => {
    callback(res);
  })
}

function deleteEMessageService(params, callback) {
  sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.Message.DELETE_E_MESSAGE, params).get(res => {
    callback(res);
  })
}